import {
    takeLatest, all, put, call, select,
} from 'redux-saga/effects';
import API from '../common/API';
import { waitAuthorizedCheck } from './Auth';
import * as Actions from '../actions/SeminarManagementViewer';

function* getListSeminarViewer(action) {
    const endpoint = `/api/v1/event/${action.payload.event_name}/seminar_unregistered/`;
    try {
        const credential = yield call(waitAuthorizedCheck);
        const resultsState = yield select((state) => state.seminarManagementViewer.listSeminarViewer.data.results);
        const response = yield call(
            API.get, {
                endpoint: `${endpoint}`,
                token: credential.data.token,
                body: {
                    ...(action.payload.sdate && { sdate: action.payload.sdate }),
                    ...(action.payload.edate && { edate: action.payload.edate }),
                    ...(action.payload.title && { title: action.payload.title }),
                    ...(action.payload?.language && { language: action.payload.language }),
                    page: action.payload.page,
                    page_size: action.payload.page_size,
                },
            },
        );
        let dataResult = {};
        if (resultsState) {
            dataResult = { ...response, results: { ...resultsState, ...response.results } };
        } else {
            dataResult = response;
        }
        yield put(Actions.GetListSeminarReceived(dataResult));
    } catch (error) {
        yield put(Actions.GetListSeminarReceivedFailure(yield error));
    }
}
function* getDetailSeminarViewer(action) {
    const endpoint = action.payload.language
        ? `/api/v1/event/${action.payload.event_name}/seminar_unregistered/${action.payload.seminar_id}/?language=${action.payload.language}`
        : `/api/v1/event/${action.payload.event_name}/seminar_unregistered/${action.payload.seminar_id}/`;
    try {
        const credential = yield call(waitAuthorizedCheck);
        const response = yield call(
            API.get, {
                endpoint: `${endpoint}`,
                token: credential.data.token,
            },
        );
        yield put(Actions.GetDetailSeminarReceived(response));
    } catch (error) {
        yield put(Actions.GetDetailSeminarReceivedFailure(yield error));
    }
}
function* getListSeminarNonAuthViewer(action) {
    const endpoint = `/api/v1/event/${action.payload.event_name}/seminar/`;
    const resultsState = yield select((state) => state.seminarManagementViewer.listSeminarNonAuthViewer.data.results);
    try {
        const response = yield call(
            API.get, {
                endpoint: `${endpoint}`,
                body: {
                    ...(action.payload.sdate && { sdate: action.payload.sdate }),
                    ...(action.payload.edate && { edate: action.payload.edate }),
                    ...(action.payload.title && { title: action.payload.title }),
                    ...(action.payload?.language && { language: action.payload.language }),
                    page: action.payload.page,
                    page_size: action.payload.page_size,
                },
            },
        );
        let dataResult = {};
        if (resultsState) {
            dataResult = { ...response, results: { ...resultsState, ...response.results } };
        } else {
            dataResult = response;
        }
        yield put(Actions.GetListSeminarNonAuthReceived(dataResult));
    } catch (error) {
        yield put(Actions.GetListSeminarNonAuthReceivedFailure(yield error));
    }
}
function* getDetailSeminarNonAuthViewer(action) {
    const endpoint = `/api/v1/event/${action.payload.event_name}/seminar_unregistered/${action.payload.seminar_id}/`;
    try {
        const response = yield call(
            API.get, {
                endpoint: `${endpoint}`,
            },
        );
        yield put(Actions.GetDetailSeminarNonAuthReceived(response));
    } catch (error) {
        yield put(Actions.GetDetailSeminarNonAuthReceivedFailure(yield error));
    }
}
function* registerSeminarViewer(action) {
    const endpoint = action.payload?.language
        ? `/api/v1/seminar/register/?language=${action.payload.language}`
        : '/api/v1/seminar/register/';
    const dataSm = action.payload?.language ? action.payload.data : action.payload;
    try {
        const credential = yield call(waitAuthorizedCheck);
        const response = yield call(
            API.post, {
                endpoint: `${endpoint}`,
                token: credential.data.token,
                body: { ...dataSm },
            },
        );
        yield put(Actions.RegisterSeminarReceived(response));
    } catch (error) {
        yield put(Actions.RegisterSeminarReceivedFailure(yield error));
    }
}

function* getListSeminarPaused(action) {
    const endpoint = action?.payload?.language
        ? `/api/v1/notification/seminar_paused/?language=${action.payload.language}`
        : '/api/v1/notification/seminar_paused/';
    try {
        const credential = yield call(waitAuthorizedCheck);
        const response = yield call(
            API.get, {
                endpoint: `${endpoint}`,
                token: credential.data.token,
            },
        );
        yield put(Actions.GetListSeminarPausedRequestedReceived(response));
    } catch (error) {
        yield put(Actions.GetListSeminarPausedRequestedReceivedFailure(yield error));
    }
}

export default function* seminarManagementViewer() {
    yield all([
        takeLatest('GET_LIST_SEMINAR_VIEWER_REQUESTED', getListSeminarViewer),
        takeLatest('GET_LIST_SEMINAR_VIEWER_NON_AUTH_REQUESTED', getListSeminarNonAuthViewer),
        takeLatest('GET_DETAIL_SEMINAR_VIEWER_REQUESTED', getDetailSeminarViewer),
        takeLatest('GET_DETAIL_SEMINAR_VIEWER_NON_AUTH_REQUESTED', getDetailSeminarNonAuthViewer),
        takeLatest('REGISTER_SEMINAR_REQUESTED', registerSeminarViewer),
        takeLatest('GET_LIST_SEMINAR_PAUSED_REQUESTED', getListSeminarPaused),
    ]);
}
